export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-slate-900 to-black border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="text-2xl font-bold text-white mb-4">TechInsight</div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Your trusted source for cutting-edge technology insights, analysis, and trends shaping the digital future.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-slate-800 text-gray-400 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-blue-600 hover:text-white transition-all cursor-pointer border border-slate-700 hover:border-transparent">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-slate-800 text-gray-400 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-blue-600 hover:text-white transition-all cursor-pointer border border-slate-700 hover:border-transparent">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-slate-800 text-gray-400 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-blue-600 hover:text-white transition-all cursor-pointer border border-slate-700 hover:border-transparent">
                <i className="ri-github-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-slate-800 text-gray-400 hover:bg-gradient-to-r hover:from-cyan-500 hover:to-blue-600 hover:text-white transition-all cursor-pointer border border-slate-700 hover:border-transparent">
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Topics */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm">Topics</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">Artificial Intelligence</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">Blockchain</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">Quantum Computing</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">Cybersecurity</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">IoT & Edge</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm">Company</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">About Us</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">Our Team</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">Careers</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">Contact</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">Advertise</a></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm">Resources</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">Newsletter</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">Podcast</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">Events</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">Privacy Policy</a></li>
              <li><a href="#" className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm">Terms of Service</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-sm">
            © 2024 TechInsight. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            className="text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer text-sm"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
